import Vue from 'vue';
import Element from 'element-ui';
import Amplify from 'aws-amplify';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/en';

import App from './App.vue';
import router from './router/router';
import store from './store';

import awsExports from './aws-exports';
import awsCognito from './aws-cognito';

Amplify.configure({ ...awsExports, ...awsCognito });

Vue.use(Element, { locale });

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),

  mounted() {
    // eslint-disable-next-line no-console
    console.log(`Kind Challenge Admin beta v${process.env.VUE_APP_VERSION} build from ${process.env.VUE_APP_BUILD_TIME}`);
  },
}).$mount('#app');
